import React from 'react';

// eslint-disable-next-line
export default () => {
    return(
        <h1>Hello world!</h1>
    )
}